const initialState = {
}

export const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}
